<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <order_list_table :orders="content" />
        </div>

        <pagination :allData="orders" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import order_list_table from '@/components/application/orders/order_list/order_list_table.vue';
import Orders from '@/data/orders.json';
import pagination from '@/layouts/elements/pagination.vue';
import { useFunctionalitiesStore } from '@/store/functionalities';
import { storeToRefs } from 'pinia';

const functionalitiesStore = useFunctionalitiesStore();
const { state } = storeToRefs(functionalitiesStore);
const orders = ref(Orders.data);

const content = computed(() => state.value.content);
</script>

<style></style>
